export type SurveyParameterDefinitionId = number;
export type SurveyParameterDefinitionKey = string;
export enum SurveyParameterType {
  INTEGER = 'integer',
  STRING = 'string',
  REFERENCE = 'reference',
}
